import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Order } from '@interfaces/OrderTypes';

// Slice espejo de `orders` para los pedidos PROGRAMADOS (estatus === 'scheduled').
// Habilita el contador reactivo de la pestaña "Programados" y el refresco en tiempo real
// cuando llega el evento WebSocket `scheduledOrderCreated`, sin refetch manual.
const initialState: Order[] = [];

type OrderId = Pick<Order, 'id'>;

export const scheduledOrdersSlice = createSlice({
  name: 'scheduledOrders',
  initialState,
  reducers: {
    initScheduledOrders: (state, action: PayloadAction<Order[]>) => {
      // Reconcilia contra el backend (verdad server) SIN perder altas por socket que llegaron
      // durante la ventana del fetch on-mount: base = filas del fetch + las que ya estaban en el
      // slice y el fetch no trae (dedup por id). Antes hacía `return [...payload]` (reemplazo), lo
      // que pisaba un `addScheduledOrder` recibido mientras el fetch estaba en vuelo → race.
      const fetched = action.payload;
      const fetchedIds = new Set(fetched.map((order) => String(order.id)));
      const socketOnly = state.filter((order) => !fetchedIds.has(String(order.id)));
      return [...fetched, ...socketOnly];
    },
    addScheduledOrder: (state, action: PayloadAction<Order>) => {
      // Dedup por id (un mismo scheduledOrderCreated entregado dos veces por el socket).
      const exists = state.find((order) => String(order.id) === String(action.payload.id));
      if (exists) return state;
      return [action.payload, ...state];
    },
    removeScheduledOrder: (state, action: PayloadAction<OrderId>) => {
      return state.filter((order) => String(order.id) !== String(action.payload.id));
    },
    reset: () => initialState,
  },
});
